import { ActivatedRoute } from '@angular/router';
import { Component, ViewEncapsulation } from '@angular/core';
import { INetworkSideNavConfigOptions } from 'Src/nvps-libraries/design/nv-sidebar-list/nv-sidebar.interface';
import { PageBannerService } from 'Src/ng2/shared/components/page-banner/page-banner.service';
import { Observable } from 'rxjs';
import { delay, map, shareReplay } from 'rxjs/operators';
import { IPageBannerMeta } from 'Src/ng2/shared/components/page-banner/page-banner.interface';
import { PartnerTypes } from 'Src/ng2/shared/typings/interfaces/partner.interface';

@Component({
  selector: 'network-standard-layout',
  templateUrl: './network-standard-layout.component.html',
  styleUrls: ['./network-standard-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NetworkStandardLayoutComponent {
  public isInMaintenanceMode: boolean;
  public sideNavOptions: INetworkSideNavConfigOptions;
  public pageBannerMeta$: Observable<IPageBannerMeta>;
  public subNavConfig$: Observable<any>;
  public navigationTabs$: Observable<any>;
  public showSubNav$: Observable<boolean>;
  public partnerType = PartnerTypes.SCHOOL_NETWORK;
  public origin = 'network-standard-layout';

  constructor (
    private route: ActivatedRoute,
    private pageBannerService: PageBannerService,
  ) { }

  ngOnInit () {
    this.pageBannerMeta$ = this.pageBannerService.getPageBannerMeta();
    this.isInMaintenanceMode = this.route.snapshot.data.maintenanceMode;
    this.sideNavOptions = this.route.snapshot.data.networkSideNavConfig;

    this.subNavConfig$ = this.pageBannerService.getSubNavConfig().pipe(
      // Share one subscription across subNavConfig$, navigationTabs$, showSubNav$,
      // and the template's multiple showSubNav$ async pipes so they stay in sync.
      shareReplay({ bufferSize: 1, refCount: true }),
    );
    this.navigationTabs$ = this.subNavConfig$.pipe(map(config => config.tabs));
    this.showSubNav$ = this.subNavConfig$.pipe(
      delay(0),
      map(config => {
        const hasTabs = config.tabs?.length > 1;
        const hasFilters = config.filterConfigs?.some(fc => fc.showFilter && fc.filterOptions?.length);
        const hasWarning = !!config.showWarningMessage && !!config.warningMessage;
        return hasTabs || hasFilters || hasWarning;
      }),
    );
  }
}
